/**
 * Exports ruler-related design tokens
 */

export const height = 4;
export const borderStyle = 'solid';
export const borderWidth = '1px';
export const borderColor = 'rgba(255, 255, 255, 0.1)';
